module.exports = __webpack_public_path__ + "static/media/day_rental.265f760c.jpeg";